import { hash } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import AnimatedTools from 'ember-animated-tools/components/animated-tools';

import ENV from 'umg-ember-backend/config/environment';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import Breadcrumb from './breadcrumb';
import Confirm from './confirm';
import FlashMessages from './flash-messages';
import Header from './header';
import Navigation from './navigation';
import styles from './styles.module.css';

const bem = getBem(styles);

export default class ApplicationComponent extends Component {
  // Services
  @service breadcrumb;
  @service media;

  // Defaults
  @tracked isNavigationOpen = !this.media.isMobile;

  constructor() {
    super(...arguments);

    this.media.on('mediaChanged', () => {
      if (this.media.isMobile) {
        this.isNavigationOpen = false;
      } else {
        this.isNavigationOpen = true;
      }
    });
  }

  // Getter and Setter
  get isDevelopment() {
    return ENV.environment === 'development';
  }

  // Functions
  toggleNavigation = () => {
    this.isNavigationOpen = !this.isNavigationOpen;
  };

  closeNavigationOnMobile = () => {
    if (this.media.isMobile) {
      this.isNavigationOpen = false;
    }
  };

  // Template
  <template>
    <div
      class={{bem
        (hash
          navigation-is-open=this.isNavigationOpen
          is-breadcrumb-visible=this.breadcrumb.isBreadcrumbVisible
        )
      }}
      ...attributes
    >
      {{#if this.isDevelopment}}
        <AnimatedTools @hideUntilKeys='Shift-KeyD' />
      {{/if}}

      <Header
        @isNavigationOpen={{this.isNavigationOpen}}
        @toggleNavigation={{this.toggleNavigation}}
      />
      <Navigation
        @isOpen={{this.isNavigationOpen}}
        @onCloseNavigation={{this.closeNavigationOnMobile}}
      />

      <Confirm />
      <FlashMessages />

      <main class={{bem 'content'}}>
        {{yield}}
      </main>

      <Breadcrumb />
    </div>
  </template>
}
